@if (pageReady) {
  <main class="gs-page alerts-page">
    <div class="gs-page-inner">
      <app-page-header [headerData]="headerData"></app-page-header>
      <div class="notification-container">
        <app-notification [pageName]="pageName"></app-notification>
      </div>
      <div class="gs-content-container">
        <form [formGroup]="alertsForm" class="reminder-container">
          @if (userEmail || userPhone) {
            <div class="current-contact-info">
              @if (userEmail) {
                <p>
                  <span class="contact-info-label">{{ pageLabels.currentEmailLabel }}</span> {{ userEmail }}
                </p>
              }
              @if (userPhone) {
                <p>
                  <span class="contact-info-label">{{ pageLabels.currentPhoneLabel }}</span> {{ userPhone }}
                  {{ userPhoneType ? " - " + userPhoneType : "" }}
                </p>
              }
            </div>
          }
          <mat-card formGroupName="BillReady" class="reminder-type">
            <h2>{{ pageLabels.billReadyText }}</h2>
            <div class="reminder-notifications">
              <div class="notification-type">
                @if (!userEmail && !accountDetail.IsPaperlessBilling) {
                  <label class="alert-cb-container disabled">
                    <i
                      tabindex="0"
                      role="checkbox"
                      aria-checked="false"
                      [attr.aria-label]="pageLabels.billReadyText + ': ' + pageLabels.emailAlertText + 'alert disabled'"
                      class="fa-regular fa-envelope fa-2x"
                    ></i>
                    <p class="alert-cb-label">{{ pageLabels.emailAlertText }}</p>
                  </label>
                } @else if (accountDetail.IsPaperlessBilling) {
                  <label class="alert-cb-container disabled checked-default">
                    <i
                      tabindex="0"
                      role="checkbox"
                      aria-checked="true"
                      [attr.aria-label]="pageLabels.billReadyText + ': ' + pageLabels.emailAlertText + 'alert disabled'"
                      class="fa-regular fa-envelope fa-2x"
                    ></i>
                    <p class="alert-cb-label">{{ pageLabels.emailAlertText }}</p>
                  </label>
                } @else {
                  <label class="alert-cb-container">
                    <input
                      formControlName="Email"
                      class="gs-fa-cb"
                      type="checkbox"
                      [attr.aria-label]="pageLabels.billReadyText + ': ' + pageLabels.emailAlertText + ' alert '"
                    />
                    <i class="fa-regular fa-envelope fa-2x"></i>
                    <p class="alert-cb-label">{{ pageLabels.emailAlertText }}</p>
                  </label>
                }
              </div>
              <div class="notification-type">
                @if (!userPhone || !userPhoneIsMobile) {
                  <label class="alert-cb-container disabled" [class.checked-default]="alertsForm.value.BillReady.Text">
                    <i
                      tabindex="0"
                      role="checkbox"
                      [attr.aria-checked]="alertsForm.value.BillReady.Text"
                      [attr.aria-label]="pageLabels.billReadyText + ': ' + pageLabels.smsAlertText + 'alert disabled'"
                      class="fa-regular fa-comment-dots fa-2x"
                    ></i>
                    <p class="alert-cb-label">{{ pageLabels.smsAlertText }}</p>
                  </label>
                } @else {
                  <label class="alert-cb-container">
                    <input
                      id="BillReadyTextInput"
                      formControlName="Text"
                      class="gs-fa-cb"
                      type="checkbox"
                      [attr.aria-label]="pageLabels.billReadyText + ': ' + pageLabels.smsAlertText + ' alert '"
                    />
                    <i class="fa-regular fa-comment-dots fa-2x"></i>
                    <p class="alert-cb-label">{{ pageLabels.smsAlertText }}</p>
                  </label>
                }
              </div>
              @if (platform !== "web") {
                <div class="notification-type">
                  <label class="alert-cb-container">
                    <input
                      formControlName="Push"
                      class="gs-fa-cb"
                      type="checkbox"
                      [attr.aria-label]="pageLabels.billReadyText + ': ' + pageLabels.pushAlertText + ' alert '"
                    />
                    <i class="fa-regular fa-bell fa-2x"></i>
                    <p class="alert-cb-label">{{ pageLabels.pushAlertText }}</p>
                  </label>
                </div>
              }
            </div>
          </mat-card>

          <mat-card formGroupName="PaymentRecieved" class="reminder-type">
            <h2>{{ pageLabels.paymentRecievedText }}</h2>
            <div class="reminder-notifications">
              <div class="notification-type">
                <label class="alert-cb-container disabled checked-default">
                  <i
                    tabindex="0"
                    role="checkbox"
                    aria-checked="true"
                    [attr.aria-label]="
                      pageLabels.paymentRecievedText + ': ' + pageLabels.emailAlertText + 'alert disabled'
                    "
                    class="fa-regular fa-envelope fa-2x"
                  ></i>
                  <p class="alert-cb-label">{{ pageLabels.emailAlertText }}</p>
                </label>
              </div>
              <div class="notification-type">
                @if (!userPhone || !userPhoneIsMobile) {
                  <label
                    class="alert-cb-container disabled"
                    [class.checked-default]="alertsForm.value.PaymentRecieved.Text"
                  >
                    <i
                      tabindex="0"
                      role="checkbox"
                      [attr.aria-checked]="alertsForm.value.PaymentRecieved.Text"
                      [attr.aria-label]="
                        pageLabels.paymentRecievedText + ': ' + pageLabels.smsAlertText + 'alert disabled'
                      "
                      class="fa-regular fa-comment-dots fa-2x"
                    ></i>
                    <p class="alert-cb-label">{{ pageLabels.smsAlertText }}</p>
                  </label>
                } @else {
                  <label class="alert-cb-container">
                    <input
                      id="PaymentRecievedTextInput"
                      #payRecSms
                      formControlName="Text"
                      [attr.aria-label]="pageLabels.paymentRecievedText + ': ' + pageLabels.smsAlertText + ' alert '"
                      class="gs-fa-cb"
                      type="checkbox"
                    />
                    <i class="fa-regular fa-comment-dots fa-2x"></i>
                    <p class="alert-cb-label">{{ pageLabels.smsAlertText }}</p>
                  </label>
                }
              </div>
              @if (platform !== "web") {
                <div class="notification-type">
                  <label class="alert-cb-container">
                    <input
                      formControlName="Push"
                      class="gs-fa-cb"
                      type="checkbox"
                      [attr.aria-label]="pageLabels.paymentRecievedText + ': ' + pageLabels.pushAlertText + ' alert '"
                    />
                    <i class="fa-regular fa-bell fa-2x"></i>
                    <p class="alert-cb-label">{{ pageLabels.pushAlertText }}</p>
                  </label>
                </div>
              }
            </div>
          </mat-card>

          @if (!accountDetail.IsAutoPay) {
            <mat-card formGroupName="BillDue" class="reminder-type">
              <h2>{{ pageLabels.billDueText }}</h2>
              <div class="reminder-notifications">
                <div class="notification-type">
                  @if (!userEmail) {
                    <label class="alert-cb-container disabled" [class.checked-default]="alertsForm.value.BillDue.Email">
                      <i
                        tabindex="0"
                        role="checkbox"
                        [attr.aria-checked]="alertsForm.value.BillDue.Email"
                        [attr.aria-label]="pageLabels.billDueText + ': ' + pageLabels.emailAlertText + 'alert disabled'"
                        class="fa-regular fa-envelope fa-2x"
                      ></i>
                      <p class="alert-cb-label">{{ pageLabels.emailAlertText }}</p>
                    </label>
                  } @else {
                    <label class="alert-cb-container">
                      <input
                        formControlName="Email"
                        class="gs-fa-cb"
                        type="checkbox"
                        [attr.aria-label]="pageLabels.billDueText + ': ' + pageLabels.emailAlertText + 'alert '"
                      />
                      <i class="fa-regular fa-envelope fa-2x"></i>
                      <p class="alert-cb-label">{{ pageLabels.emailAlertText }}</p>
                    </label>
                  }
                </div>
                <div class="notification-type">
                  @if (!userPhone || !userPhoneIsMobile) {
                    <label class="alert-cb-container disabled" [class.checked-default]="alertsForm.value.BillDue.Text">
                      <i
                        tabindex="0"
                        role="checkbox"
                        [attr.aria-checked]="alertsForm.value.BillDue.Text"
                        [attr.aria-label]="pageLabels.billDueText + ': ' + pageLabels.smsAlertText + 'alert disabled'"
                        class="fa-regular fa-comment-dots fa-2x"
                      ></i>
                      <p class="alert-cb-label">{{ pageLabels.smsAlertText }}</p>
                    </label>
                  } @else {
                    <label class="alert-cb-container">
                      <input
                        id="BillDueTextInput"
                        formControlName="Text"
                        class="gs-fa-cb"
                        type="checkbox"
                        [attr.aria-label]="pageLabels.billDueText + ': ' + pageLabels.smsAlertText + 'alert '"
                      />
                      <i class="fa-regular fa-comment-dots fa-2x"></i>
                      <p class="alert-cb-label">{{ pageLabels.smsAlertText }}</p>
                    </label>
                  }
                </div>
                @if (platform !== "web") {
                  <div class="notification-type">
                    <label class="alert-cb-container">
                      <input
                        formControlName="Push"
                        class="gs-fa-cb"
                        type="checkbox"
                        [attr.aria-label]="pageLabels.billDueText + ': ' + pageLabels.pushAlertText + 'alert '"
                      />
                      <i class="fa-regular fa-bell fa-2x"></i>
                      <p class="alert-cb-label">{{ pageLabels.pushAlertText }}</p>
                    </label>
                  </div>
                }
              </div>
            </mat-card>
          } @else {
            <mat-card formGroupName="AutopayDraft" class="reminder-type">
              <h2>{{ pageLabels.autopayDraftText }}</h2>
              <div class="reminder-notifications">
                <div class="notification-type">
                  @if (!userEmail) {
                    <label
                      class="alert-cb-container disabled"
                      [class.checked-default]="alertsForm.value.AutopayDraft.Email"
                    >
                      <i
                        tabindex="0"
                        role="checkbox"
                        [attr.aria-checked]="alertsForm.value.AutopayDraft.Email"
                        [attr.aria-label]="
                          pageLabels.autopayDraftText + ': ' + pageLabels.emailAlertText + 'alert disabled'
                        "
                        class="fa-regular fa-envelope fa-2x"
                      ></i>
                      <p class="alert-cb-label">{{ pageLabels.emailAlertText }}</p>
                    </label>
                  } @else {
                    <label class="alert-cb-container">
                      <input
                        formControlName="Email"
                        class="gs-fa-cb"
                        type="checkbox"
                        [attr.aria-label]="pageLabels.autopayDraftText + ': ' + pageLabels.emailAlertText + 'alert '"
                      />
                      <i class="fa-regular fa-envelope fa-2x"></i>
                      <p class="alert-cb-label">{{ pageLabels.emailAlertText }}</p>
                    </label>
                  }
                </div>
                <div class="notification-type">
                  @if (!userPhone || !userPhoneIsMobile) {
                    <label
                      class="alert-cb-container disabled"
                      [class.checked-default]="alertsForm.value.AutopayDraft.Text"
                    >
                      <i
                        tabindex="0"
                        role="checkbox"
                        [attr.aria-checked]="alertsForm.value.AutopayDraft.Text"
                        [attr.aria-label]="
                          pageLabels.autopayDraftText + ': ' + pageLabels.smsAlertText + 'alert disabled'
                        "
                        class="fa-regular fa-comment-dots fa-2x"
                      ></i>
                      <p class="alert-cb-label">{{ pageLabels.smsAlertText }}</p>
                    </label>
                  } @else {
                    <label class="alert-cb-container">
                      <input
                        id="AutopayDraftTextInput"
                        formControlName="Text"
                        class="gs-fa-cb"
                        type="checkbox"
                        [attr.aria-label]="pageLabels.autopayDraftText + ': ' + pageLabels.smsAlertText + 'alert'"
                      />
                      <i class="fa-regular fa-comment-dots fa-2x"></i>
                      <p class="alert-cb-label">{{ pageLabels.smsAlertText }}</p>
                    </label>
                  }
                </div>
                @if (platform !== "web") {
                  <div class="notification-type">
                    <label class="alert-cb-container">
                      <input
                        formControlName="Push"
                        class="gs-fa-cb"
                        type="checkbox"
                        [attr.aria-label]="pageLabels.autopayDraftText + ': ' + pageLabels.pushAlertText + 'alert'"
                      />
                      <i class="fa-regular fa-bell fa-2x"></i>
                      <p class="alert-cb-label">{{ pageLabels.pushAlertText }}</p>
                    </label>
                  </div>
                }
              </div>
            </mat-card>
          }

          <!-- Uncomment the following block when renewal alerts are available -->
          @if (showRenewalAlert) {
            <mat-card formGroupName="Renewal" class="reminder-type">
              <h2>{{ pageLabels.renewalReadyText }}</h2>
              <div class="reminder-notifications">
                <div class="notification-type">
                  <label class="alert-cb-container disabled checked-default">
                    <i
                      tabindex="0"
                      role="checkbox"
                      aria-checked="true"
                      [attr.aria-label]="
                        pageLabels.renewalReadyText + ': ' + pageLabels.emailAlertText + 'alert disabled'
                      "
                      class="fa-regular fa-envelope fa-2x"
                    ></i>
                    <p class="alert-cb-label">{{ pageLabels.emailAlertText }}</p>
                  </label>
                </div>
                <div class="notification-type">
                  @if (!userPhone || !userPhoneIsMobile) {
                    <label class="alert-cb-container disabled" [class.checked-default]="alertsForm.value.Renewal.Text">
                      <i
                        tabindex="0"
                        role="checkbox"
                        [attr.aria-checked]="alertsForm.value.Renewal.Text"
                        [attr.aria-label]="
                          pageLabels.renewalReadyText + ': ' + pageLabels.smsAlertText + 'alert disabled'
                        "
                        class="fa-regular fa-comment-dots fa-2x"
                      ></i>
                      <p class="alert-cb-label">{{ pageLabels.smsAlertText }}</p>
                    </label>
                  } @else {
                    <label class="alert-cb-container">
                      <input
                        id="RenewalTextInput"
                        formControlName="Text"
                        class="gs-fa-cb"
                        type="checkbox"
                        [attr.aria-label]="pageLabels.renewalReadyText + ': ' + pageLabels.smsAlertText + ' alert '"
                      />
                      <i class="fa-regular fa-comment-dots fa-2x"></i>
                      <p class="alert-cb-label">{{ pageLabels.smsAlertText }}</p>
                    </label>
                  }
                </div>
                @if (platform !== "web") {
                  <div class="notification-type">
                    <label class="alert-cb-container">
                      <input
                        formControlName="Push"
                        class="gs-fa-cb"
                        type="checkbox"
                        [attr.aria-label]="pageLabels.renewalReadyText + ': ' + pageLabels.pushAlertText + ' alert '"
                      />
                      <i class="fa-regular fa-bell fa-2x"></i>
                      <p class="alert-cb-label">{{ pageLabels.pushAlertText }}</p>
                    </label>
                  </div>
                }
              </div>
            </mat-card>
          }
        </form>
        <p>
          {{ pageLabels.alertDisclaimerText }}
        </p>
        <div class="cta-container">
          <button mat-flat-button class="gs-form-button-primary" color="primary" (click)="savePreferences()">
            {{ pageLabels.saveButtonText }}
          </button>
          <a [routerLink]="pageLabels.bottomLinkUrl.value.data.url" [attr.aria-label]="pageLabels.bottomLinkAria">{{
            pageLabels.bottomLinkText
          }}</a>
        </div>
      </div>
    </div>
  </main>
}
